// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-03-17T14:51:29.879Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const ImportProfileListView = lazy(() => import('@/integration/ImportProfileListView').then(m => ({ default: m.ImportProfileListView })));
const ImportProfileDetailView = lazy(() => import('@/integration/ImportProfileDetailView').then(m => ({ default: m.ImportProfileDetailView })));
const IntegrationCallRecordListView = lazy(() => import('@/integration/IntegrationCallRecordListView').then(m => ({ default: m.IntegrationCallRecordListView })));
const IntegrationCallRecordDetailView = lazy(() => import('@/integration/IntegrationCallRecordDetailView').then(m => ({ default: m.IntegrationCallRecordDetailView })));
const IntegrationClientListView = lazy(() => import('@/integration/IntegrationClientListView').then(m => ({ default: m.IntegrationClientListView })));
const IntegrationClientDetailView = lazy(() => import('@/integration/IntegrationClientDetailView').then(m => ({ default: m.IntegrationClientDetailView })));
const IntegrationConnectionListView = lazy(() => import('@/integration/IntegrationConnectionListView').then(m => ({ default: m.IntegrationConnectionListView })));
const IntegrationConnectionDetailView = lazy(() => import('@/integration/IntegrationConnectionDetailView').then(m => ({ default: m.IntegrationConnectionDetailView })));
const IntegrationJobListView = lazy(() => import('@/integration/IntegrationJobListView').then(m => ({ default: m.IntegrationJobListView })));
const IntegrationJobDetailView = lazy(() => import('@/integration/IntegrationJobDetailView').then(m => ({ default: m.IntegrationJobDetailView })));
const IntegrationOutboxRecordListView = lazy(() => import('@/integration/IntegrationOutboxRecordListView').then(m => ({ default: m.IntegrationOutboxRecordListView })));
const IntegrationOutboxRecordDetailView = lazy(() => import('@/integration/IntegrationOutboxRecordDetailView').then(m => ({ default: m.IntegrationOutboxRecordDetailView })));
const IntegrationRunListView = lazy(() => import('@/integration/IntegrationRunListView').then(m => ({ default: m.IntegrationRunListView })));
const IntegrationRunDetailView = lazy(() => import('@/integration/IntegrationRunDetailView').then(m => ({ default: m.IntegrationRunDetailView })));
const IntegrationStagingRecordListView = lazy(() => import('@/integration/IntegrationStagingRecordListView').then(m => ({ default: m.IntegrationStagingRecordListView })));
const IntegrationStagingRecordDetailView = lazy(() => import('@/integration/IntegrationStagingRecordDetailView').then(m => ({ default: m.IntegrationStagingRecordDetailView })));

/**
 * Integration Module Routes
 */
export const integrationRoutes = [
{ path: '/integration/importprofiles',
element: <Suspense><ImportProfileListView /></Suspense> },
{ path: '/integration/importprofiles/:id',
element: <Suspense><ImportProfileDetailView /></Suspense> },
{ path: '/integration/integrationcallrecords',
element: <Suspense><IntegrationCallRecordListView /></Suspense> },
{ path: '/integration/integrationcallrecords/:id',
element: <Suspense><IntegrationCallRecordDetailView /></Suspense> },
{ path: '/integration/integrationclients',
element: <Suspense><IntegrationClientListView /></Suspense> },
{ path: '/integration/integrationclients/:id',
element: <Suspense><IntegrationClientDetailView /></Suspense> },
{ path: '/integration/integrationconnections',
element: <Suspense><IntegrationConnectionListView /></Suspense> },
{ path: '/integration/integrationconnections/:id',
element: <Suspense><IntegrationConnectionDetailView /></Suspense> },
{ path: '/integration/integrationconnections/template/new',
element: <Suspense><IntegrationConnectionDetailView mode="template" /></Suspense> },
{ path: '/integration/integrationconnections/template/:templateId',
element: <Suspense><IntegrationConnectionDetailView mode="template" /></Suspense> },
{ path: '/integration/integrationjobs',
element: <Suspense><IntegrationJobListView /></Suspense> },
{ path: '/integration/integrationjobs/:id',
element: <Suspense><IntegrationJobDetailView /></Suspense> },
{ path: '/integration/integrationjobs/template/new',
element: <Suspense><IntegrationJobDetailView mode="template" /></Suspense> },
{ path: '/integration/integrationjobs/template/:templateId',
element: <Suspense><IntegrationJobDetailView mode="template" /></Suspense> },
{ path: '/integration/integrationoutboxrecords',
element: <Suspense><IntegrationOutboxRecordListView /></Suspense> },
{ path: '/integration/integrationoutboxrecords/:id',
element: <Suspense><IntegrationOutboxRecordDetailView /></Suspense> },
{ path: '/integration/integrationruns',
element: <Suspense><IntegrationRunListView /></Suspense> },
{ path: '/integration/integrationruns/:id',
element: <Suspense><IntegrationRunDetailView /></Suspense> },
{ path: '/integration/integrationstagingrecords',
element: <Suspense><IntegrationStagingRecordListView /></Suspense> },
{ path: '/integration/integrationstagingrecords/:id',
element: <Suspense><IntegrationStagingRecordDetailView /></Suspense> }
];
